import { useTranslation } from 'react-i18next';

import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/cn';
import { formatAgeHours } from '../../lib/format';
import type { Staleness } from '../../types';

const TONE: Record<Staleness, string> = {
  fresh: 'bg-status-success/10 text-emerald-700 dark:text-emerald-300',
  aging: 'bg-status-warning/15 text-amber-800 dark:text-amber-300',
  stale: 'bg-elevated text-text-muted',
  archived: 'bg-elevated text-text-muted',
};

/**
 * How old a time-sensitive report is. Shared by every community-report surface
 * (test seats, embassy status, payment methods) so freshness reads the same everywhere.
 */
export function StalenessBadge({ staleness, ageHours, className }: { staleness: Staleness; ageHours: number; className?: string }) {
  const { t } = useTranslation();
  const { language } = useLanguage();
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium', TONE[staleness], className)}
      title={t(`trust.staleness.${staleness}Hint`)}
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      <span>{t(`trust.staleness.${staleness}`)}</span>
      <span className="font-normal opacity-80">{formatAgeHours(ageHours, language)}</span>
    </span>
  );
}
